import { RestClient } from '@/api/rest-client'
import { PageResult } from '@/api/types'
import { TypeformForm } from '@/api/model/typeform/typeform-form'

export class TypeformFormClient extends RestClient<TypeformForm> {
    collectionName = 'service/typeform/forms'
    parseData = TypeformForm.fromData

    async get(id: string, fresh: boolean = false): Promise<TypeformForm> {
        try {
            const cached = this.cache.get(id)
            if (!fresh && cached !== undefined) {
                return cached
            }

            const generation = this.cacheGeneration
            const response = await this.client.get(`${this.basePath}/${this.collectionName}/${id}`, {
                headers: {
                    Accept: 'application/json',
                },
            })
            const data = this.parseData(response.data) as TypeformForm
            this.remember(id, data, generation)

            return data

        } catch (error) {
            this.handleError(error)
        }
    }

    async getAll(params: any = {}): Promise<TypeformForm[]> {
        try {
            const response = await this.client.get(`${this.basePath}/${this.collectionName}`, {
                params,
                headers: {
                    Accept: 'application/json',
                },
            })

            const collection = response.data.items as any[]
            return collection.map(value => this.parseData(value))

        } catch (error) {
            this.handleError(error)
        }
    }

    async getPaged(params: any): Promise<PageResult<TypeformForm>> {
        try {
            const response = await this.client.get(`${this.basePath}/${this.collectionName}`, {
                params,
                headers: {
                    Accept: 'application/json',
                },
            })

            const totalItems = response.data.total_items
            const totalPages = response.data.page_count
            const collection = (response.data.items as any[])
                .map(value => this.parseData(value))

            return {
                collection,
                totalItems,
                totalPages,
            }

        } catch (error) {
            this.handleError(error)
        }
    }

    async update(id: string, data: any): Promise<TypeformForm> {
        const response = await this.client.put(`${this.basePath}/${this.collectionName}/${id}`, data.toRequestData(), {
            headers: {
                Accept: 'application/json',
            },
        })
        return await this.get(id, true)
    }
}
